import { PatientsView } from "@/features/patients/components/PatientsView"

export default function PatientsPage() {
  return <PatientsView />
}